module.exports = __webpack_public_path__ + "static/media/small_presto_logo.9f938c98.svg";